import { fromJS } from 'immutable';
import config from '../../../config';
import actions from '../../constants/portal/prozorro';
import {checkJsonResponse, logErrorConsole} from 'utils/actions';

export const tendersAreLoading = (data) => ({
  type: actions.TENDERS_ARE_LOADING,
  data
})

export const loadTenders = (limit=25, offset=10) => (dispatch) => {
  dispatch(tendersAreLoading(true));
  fetch(`${config.apiHost}/prozorro/?limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_TENDERS,
      data
    });
    dispatch(tendersAreLoading(false))
  })
  .catch(logErrorConsole)
};



// WEBPACK FOOTER //
// ./src/redux/actions/portal/prozorro.js